module.exports = __webpack_public_path__ + "assets/img/tick.639926d3.svg";